import './Footer.css'

const Footer = (props: React.PropsWithChildren) => {
  return <div className="footer body-sm">{props.children}</div>
};

export default Footer;
